// extracted by mini-css-extract-plugin
export var buttons = "_a8-0";
export var buttonsActive = "_a8-h";
export var cancelConfirm = "_a8-1";
export var closeButton = "_a8-2";
export var column = "_a8-3";
export var container = "_a8-4";
export var detailHeader = "_a8-6";
export var detailTitle = "_a8-7";
export var detailsContent = "_a8-5";
export var header = "_a8-8";
export var headerWithClose = "_a8-9";
export var icon = "_a8-a";
export var infoIcon = "_a8-c";
export var informationContainer = "_a8-b";
export var sideDrawer = "_a8-d";
export var sideDrawerOpen = "_a8-e";
export var stickyFooter = "_a8-f";
export var typeOption = "_a8-g";